import { ModuleId, SectionId, TreePath } from '@nirvana/shared/dtos/types/policies/common';
import _ from 'lodash';

export const PolicyPanelInfoLinks = {
  [ModuleId.POLICY_SETTINGS]: {
    [SectionId.DETAILS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342923-details.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342923-details.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342923-details.html',
      },
    },
    [SectionId.GENERAL_INHERITANCE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-1180476-inheritance-rules.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-1180476-inheritance-rules.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-1180476-inheritance-rules.html',
      },
    },
  },
  [ModuleId.GENERAL]: {
    [SectionId.SECURITY_TELEMETRY]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342928-security-telemetry.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342928-security-telemetry.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342928-security-telemetry.html',
      },
    },
    [SectionId.COMMUNICATION]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342926-communication.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342926-communication.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342926-communication.html',
      },
    },
    [SectionId.SETTINGS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342925-settings.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342925-settings.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342925-settings.html',
      },
    },
    [SectionId.GENERAL_NOTIFICATIONS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342924-notifications.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342924-notifications.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342924-notifications.html',
      },
    },
    [SectionId.UPDATE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342927-update.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342927-update.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342927-update.html',
      },
    },
  },
  [ModuleId.PATCH_MANAGEMENT]: {
    [SectionId.NONE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342968-patch-management.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342968-patch-management.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342968-patch-management.html',
      },
    },
  },

  [ModuleId.DEVICE_CONTROL]: {
    [SectionId.RULES]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342969-device-control.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342969-device-control.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342969-device-control.html',
      },
    },
    [SectionId.EXCLUSIONS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342971-device-control-configuration.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342971-device-control-configuration.html',
        onPremiseCustomer:
          'https://www.bitdefender.com/business/support/en/77212-342971-device-control-configuration.html',
      },
    },
  },
  [ModuleId.INTEGRITY_MONITOR]: {
    [SectionId.INTEGRITY_MONITOR_REAL_TIME]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342972-integrity-monitoring.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342972-integrity-monitoring.html',
      },
    },
  },
  [ModuleId.EDR_SENSOR]: {
    [SectionId.GENERAL]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342982-incidents-sensor.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342982-incidents-sensor.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342982-incidents-sensor.html',
      },
    },
  },
  [ModuleId.LIVE_SEARCH]: {
    [SectionId.NONE]: {
      support: {
        cloudPartner:
          'https://www.bitdefender.com/business/support/en/77211-151142-investigating-incidents.html#UUID-0cdbdccf-eb31-3a49-427a-3148b2f90008',
        cloudCustomer:
          'https://www.bitdefender.com/business/support/en/77209-151142-investigating-incidents.html#UUID-0cdbdccf-eb31-3a49-427a-3148b2f90008',
      },
    },
  },
  [ModuleId.ENCRYPTION]: {
    [SectionId.GENERAL]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342979-full-disk-encryption.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342979-full-disk-encryption.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342979-full-disk-encryption.html',
      },
    },
  },
  [ModuleId.STORAGE_PROTECTION]: {
    [SectionId.STORAGE_PROTECTION_ICAP]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342984-security-for-storage.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342984-security-for-storage.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342984-security-for-storage.html',
      },
    },
    [SectionId.EXCLUSIONS]: {
      support: {
        cloudPartner:
          'https://www.bitdefender.com/business/support/en/77211-342984-security-for-storage.html#UUID-ecfc7a3f-7c27-da94-d662-81f9bcaff6e8_section-idm63249966268810',
        cloudCustomer:
          'https://www.bitdefender.com/business/support/en/77209-342984-security-for-storage.html#UUID-ecfc7a3f-7c27-da94-d662-81f9bcaff6e8_section-idm63249966268810',
        onPremiseCustomer:
          'https://www.bitdefender.com/business/support/en/77212-342984-security-for-storage.html#UUID-ecfc7a3f-7c27-da94-d662-81f9bcaff6e8_section-idm63249966268810',
      },
    },
  },
  [ModuleId.INDICATORS_OF_RISK]: {
    [SectionId.NONE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342985-risk-management.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342985-risk-management.html',
      },
      fullDescription: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-101643-ior.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-101643-ior.html',
      } as SupportLink,
    },
  },
  [ModuleId.BLOCKLIST_RULES]: {
    [SectionId.NONE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-1137780-blocklist.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-1137780-blocklist.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-1137780-blocklist.html',
      },
      fullDescription: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-1137780-blocklist.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-1137780-blocklist.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-1137780-blocklist.html',
      } as SupportLink,
    },
  },
  [ModuleId.PHASR]: {
    [SectionId.NONE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/pahsr.hmtl',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/pahsr.hmtl',
      },
      fullDescription: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/pahsr.hmtl',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/pahsr.hmtl',
      } as SupportLink,
    },
  },
  [ModuleId.RELAY]: {
    [SectionId.COMMUNICATION]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342973-relay.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342973-relay.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342973-relay.html',
      },
      networkDiscovery: {
        cloudPartner:
          'https://www.bitdefender.com/business/support/en/77211-155221-best-practices.html#UUID-06d6f311-ca5c-e99f-556b-d1c5ae289e4b',
        cloudCustomer:
          'https://www.bitdefender.com/business/support/en/77209-155221-best-practices.html#UUID-06d6f311-ca5c-e99f-556b-d1c5ae289e4b',
        onPremiseCustomer:
          'https://www.bitdefender.com/business/support/en/77212-155221-best-practices.html#UUID-06d6f311-ca5c-e99f-556b-d1c5ae289e4b',
      },
    },
    [SectionId.UPDATE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342973-relay.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342973-relay.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342973-relay.html',
      },
    },
  },
  [ModuleId.EXCHANGE_PROTECTION]: {
    [SectionId.GENERAL]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342975-general.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342975-general.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342975-general.html',
      },
    },
    [SectionId.EXCHANGE_ANTIMALWARE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342978-antimalware.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342978-antimalware.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342978-antimalware.html',
      },
    },
    [SectionId.EXCHANGE_CONTENT_CONTROL]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342977-content-control.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342977-content-control.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342977-content-control.html',
      },
    },
    [SectionId.EXCHANGE_ANTISPAM]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342976-antispam.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342976-antispam.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342976-antispam.html',
      },
    },
  },
  [ModuleId.SANDBOX]: {
    [SectionId.ENDPOINT_SENSOR]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342957-sandbox-analyzer.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342957-sandbox-analyzer.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342957-sandbox-analyzer.html',
      },
    },
    [SectionId.NETWORK_SENSOR]: {
      support: {
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77458-311783-network-sensor.html',
      },
    },
    [SectionId.ICAP_SENSOR]: {
      support: {
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77458-311784-icap-sensor.html',
      },
    },
    [SectionId.SANDBOX_MANAGER]: {
      support: {
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77458-311785-sandbox-manager.html',
      },
    },
  },
  [ModuleId.APPLICATION_CONTROL]: {
    [SectionId.NONE]: {
      support: {
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342956-application-control.html',
      },
    },
  },
  [ModuleId.NSX]: {
    [SectionId.NONE]: {
      support: {
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342983-nsx.html',
      },
    },
  },
  [ModuleId.FIREWALL]: {
    [SectionId.SETTINGS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342959-firewall.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342959-firewall.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342959-firewall.html',
      },
    },
    [SectionId.FIREWALL_NETWORK]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342961-settings.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342961-settings.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342961-settings.html',
      },
    },
    [SectionId.FIREWALL_ADVANCED]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342962-rules.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342962-rules.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342962-rules.html',
      },
      suggestionList: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-92656-system-variables.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-92656-system-variables.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-92656-system-variables.html',
      },
    },
  },
  [ModuleId.CONTENT_CONTROL]: {
    [SectionId.CONTENT_CONTROL_TRAFFIC]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342964-general.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342964-general.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342964-general.html',
      },
    },
    [SectionId.CONTENT_CONTROL_DATA_PROTECTION]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342966-web-protection.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342966-web-protection.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342966-web-protection.html',
      },
    },
    [SectionId.CONTENT_CONTROL_NETWORK_MONITOR]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342967-network-attacks.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342967-network-attacks.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342967-network-attacks.html',
      },
    },
    [SectionId.CONTENT_CONTROL_WEB]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342965-content-control.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342965-content-control.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342965-content-control.html',
      },
      suggestionList: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-92656-system-variables.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-92656-system-variables.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-92656-system-variables.html',
      },
    },
  },
  [ModuleId.ANTIMALWARE]: {
    [SectionId.ANTIMALWARE_ON_ACCESS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342930-on-access.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342930-on-access.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342930-on-access.html',
      },
    },
    [SectionId.ANTIMALWARE_ON_EXECUTE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342932-on-execute.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342932-on-execute.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342932-on-execute.html',
      },
    },
    [SectionId.ANTIMALWARE_ANTI_TAMPERING]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-537435-anti-tampering.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-537435-anti-tampering.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-537435-anti-tampering.html',
      },
    },
    [SectionId.ANTIMALWARE_DYNAMIC_THREAT_DEFENSE]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342938-hyperdetect.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342938-hyperdetect.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342938-hyperdetect.html',
      },
    },
    [SectionId.ANTIMALWARE_ANTI_EXPLOIT]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342939-advanced-anti-exploit.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342939-advanced-anti-exploit.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342939-advanced-anti-exploit.html',
      },
    },
    [SectionId.ANTIMALWARE_SECURITY_SERVERS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342949-security-servers.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342949-security-servers.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342949-security-servers.html',
      },
    },
    [SectionId.ANTIMALWARE_ON_DEMAND]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342937-on-demand.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342937-on-demand.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342937-on-demand.html',
      },
      archiveInfo: {
        cloudPartner:
          'https://www.bitdefender.com/business/support/en/77211-80154-types-of-archives-scanned-by-bitdefender-endpoint-security-tools.html',
        cloudCustomer:
          'https://www.bitdefender.com/business/support/en/77209-80154-types-of-archives-scanned-by-bitdefender-endpoint-security-tools.html',
        onPremiseCustomer:
          'https://www.bitdefender.com/business/support/en/77212-80154-types-of-archives-scanned-by-bitdefender-endpoint-security-tools.html',
      },
      suggestionList: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-92656-system-variables.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-92656-system-variables.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-92656-system-variables.html',
      },
    },
    [SectionId.SETTINGS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-342940-settings.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-342940-settings.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-342940-settings.html',
      },
    },
    [SectionId.EXCLUSIONS]: {
      support: {
        cloudPartner: 'https://www.bitdefender.com/business/support/en/77211-1180477-exclusions.html',
        cloudCustomer: 'https://www.bitdefender.com/business/support/en/77209-1180477-exclusions.html',
        onPremiseCustomer: 'https://www.bitdefender.com/business/support/en/77212-1180477-exclusions.html',
      },
    },
  },
};

export interface SupportLink {
  cloudPartner?: string;
  cloudCustomer?: string;
  onPremiseCustomer?: string;
}

/**
 * Get full description link for the given path.
 * @param {TreePath} treePath
 * @param propertyPath
 * @returns {string}
 */
export function getSupportLinkForPlatform(treePath: TreePath, propertyPath: string[]): string {
  const supportLink = _.get(
    PolicyPanelInfoLinks[treePath.moduleId][treePath.sectionId],
    propertyPath,
    {}
  ) as SupportLink;

  const isPartner = Application.Main.company.isPartner();
  const isCloudCustomer = Application.Main.product.isCloud() && Application.Main.company.isCustomer();
  const isOnPremiseCustomer = !Application.Main.product.isCloud() && Application.Main.company.isCustomer();

  if (isPartner && supportLink.cloudPartner) {
    return supportLink.cloudPartner;
  }

  if (isCloudCustomer && supportLink.cloudCustomer) {
    return supportLink.cloudCustomer;
  }

  if (isOnPremiseCustomer && supportLink.onPremiseCustomer) {
    return supportLink.onPremiseCustomer;
  }

  return 'javascript:void(0);';
}
